// extracted by mini-css-extract-plugin
module.exports = {"applabel":"index_applabel__2rDP-","gpname":"index_gpname__-dviS"};